import { useQuery } from '@tanstack/react-query';
import { storageRoomService } from '../services/storageRoom.service';
import {
  hasUsableStorageRooms,
  shouldRedirectToStorageSetup,
} from '../utils/sampleStorageSetupGate';

/**
 * サンプル一覧／ケース管理用。保管庫 0 件なら保管庫セットアップへ誘導する判定。
 * Local Zip / Cloud DB は storageRoomService が吸収。
 */
export function useSampleStorageSetupGate(adminViewAll = false): {
  /** 件数判定が終わるまで false（チラつき防止） */
  isReady: boolean;
  isError: boolean;
  shouldRedirect: boolean;
  hasStorageRooms: boolean;
  total: number | undefined;
} {
  const { data, isError, isFetched } = useQuery({
    queryKey: ['storageRooms', 'setupGate', Boolean(adminViewAll)],
    queryFn: () =>
      storageRoomService.list({
        page: 1,
        limit: 1,
        adminViewAll: adminViewAll || undefined,
      }),
    staleTime: 30_000,
  });

  const total = data?.pagination?.total;
  const isReady = isFetched || isError;

  return {
    isReady,
    isError,
    shouldRedirect: shouldRedirectToStorageSetup({
      isReady: isFetched,
      isError,
      total,
    }),
    hasStorageRooms: hasUsableStorageRooms(total ?? null),
    total: typeof total === 'number' ? total : undefined,
  };
}
